export const TOKEN_STORAGE_KEY = '@Conexa:token'

export const USER_STORAGE_KEY = '@Conexa:user'

export const VALIDATION_CODE_TIMER = 76

export const IS_PRODUCTION = process.env.REACT_APP_ENV_NAME === 'PRODUCTION'
